<template>
  <div class="page-listing-list">
    <div v-if="applicantsPage" class="listing-results">
      <template v-if="applicantsPage.results.length">
        <div class="listing-grid">
          <ApplicantListEntry
            v-for="applicant of applicantsPage.results"
            :key="applicant.id"
            :applicant="applicant"
            @openPreview="openPreview(applicant.id)"
            @delete="confirmDeleteRecord(applicant.id)"
          />
        </div>
      </template>
      <template v-else>
        <p>Keine Ergebnisse gefunden</p>
      </template>

      <vs-pagination
        v-if="applicantsPage"
        v-model="currentPage"
        :total="totalPages"
        :max="7"
        icon-pack="fas"
        prev-icon="fa-chevron-left"
        next-icon="fa-chevron-right"
      />
      <ApplicantPreview />
    </div>

    <div class="page-listing-filter">
      <div class="page-listing-filter-fixed">
        <div v-if="applicantsPage" style="padding: 0 18px; color: grey">
          Ergebnisse: {{ applicantsPage.total }}
        </div>
        <div
          class="filter-title"
          style="padding: 5px 18px 0"
          :class="{ active: mobileFilterOpen }"
          @click="mobileFilterOpen = !mobileFilterOpen"
        >
          Filter-Center
          <div
            v-if="$apollo.queries.applicantsPage.loading"
            class="loading-animation"
          >
            <i class="fad fa-spinner-third"></i>
          </div>
          <span v-if="currentFilterPreset"
            >- {{ currentFilterPreset.name }}</span
          >
          <i class="far fa-chevron-down"></i>
        </div>
        <div
          v-if="filter.onlyNew == false"
          class="mb-4"
          style="padding: 0 18px"
        >
          <span
            class="sm:mb-2 md:mb-3 cursor-pointer clearFilter"
            @click="clearFilter"
            >Filter zurücksetzen <i class="far fa-sliders-v"></i
          ></span>
        </div>
        <div
          class="page-listing-filter--inputs"
          :class="{ active: mobileFilterOpen }"
        >
          <div class="vx-row" style="padding: 0 18px">
            <div class="vx-col w-full lg:w-1/2">
              <DataInput
                v-model="filter.fullTextSearch"
                type="text"
                placeholder="Suche..."
                class="w-full"
                name="fullTextSearch"
                label="Bewerbersuche"
                @input="resetPage"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2">
              <DataInput
                v-if="filter.onlyNew == false"
                v-model="filter.documentTextSearch"
                type="text"
                placeholder="Suche..."
                class="w-full"
                name="documentTextSearch"
                label="Dokumentensuche"
                @input="resetPage"
              />
            </div>
          </div>
          <vs-collapse>
            <vs-collapse-item>
              <div slot="header">Mobilität</div>
              <div class="vx-row">
                <div class="vx-col w-full md:w-3/5">
                  <label class="text-sm opacity-75">Adresse</label>
                  <DataInput
                    v-model="filter.address"
                    :model-replaces="$route.query.formatted_address"
                    type="address-autocomplete"
                    name="address"
                    output="latlng"
                    placeholder="Adresse"
                    @input="changeAddressFilter"
                  />
                </div>
                <div
                  v-if="filter.address || $route.query.formatted_address"
                  class="vx-col w-full md:w-2/5"
                >
                  <label class="text-sm opacity-75">Radius (km)</label>
                  <DataInput
                    v-model="filter.locationRadius"
                    type="number"
                    placeholder="Radius"
                    name="addressRadius"
                    multiple
                    gql-query="applicantSkillJobTypes"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col w-full md:w-1/2"
                >
                  <label class="text-sm opacity-75">PKW</label>
                  <DataInput
                    v-model="filter.ownCar"
                    type="select"
                    :options="[
                      { code: true, label: 'Ja' },
                      { code: false, label: 'Nein' }
                    ]"
                    placeholder="PKW"
                    name="ownCar"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col w-full md:w-1/2"
                >
                  <label class="text-sm opacity-75">Motorrad</label>
                  <DataInput
                    v-model="filter.mobilityMotorcycle"
                    type="select"
                    :options="[
                      { code: true, label: 'Ja' },
                      { code: false, label: 'Nein' }
                    ]"
                    placeholder="Motorrad"
                    name="mobilityMotorcycle"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col w-full md:w-1/2"
                >
                  <label class="text-sm opacity-75">Fahrrad</label>
                  <DataInput
                    v-model="filter.mobilityBicycle"
                    type="select"
                    :options="[
                      { code: true, label: 'Ja' },
                      { code: false, label: 'Nein' }
                    ]"
                    placeholder="Fahrrad"
                    name="mobilityBicycle"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col w-full md:w-1/2"
                >
                  <label class="text-sm opacity-75">ÖPNV</label>
                  <DataInput
                    v-model="filter.mobilityPublicTransport"
                    type="select"
                    :options="[
                      { code: true, label: 'Ja' },
                      { code: false, label: 'Nein' }
                    ]"
                    placeholder="ÖPNV"
                    name="mobilityPublicTransport"
                    @input="resetPage"
                  />
                </div>
              </div>
            </vs-collapse-item>
            <vs-collapse-item>
              <div slot="header">Bewerber-Daten</div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <label class="text-sm opacity-75">Geimpft oder Genesen</label>
                  <DataInput
                    v-model="filter.vaccinatedOrRecovered"
                    name="filterVaccinatedOrRecovered"
                    type="bool"
                    @input="resetPage"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="text-sm opacity-75">Nur alte Bewerber</label>
                  <DataInput
                    v-model="filter.onlyOld"
                    name="filterOnlyOld"
                    type="bool"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Eingangsart</label>
                  <DataInput
                    v-model="filter.entryType"
                    type="model"
                    placeholder="Eingangsart"
                    multiple
                    gql-query="applicantEntryTypes"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Quelle</label>
                  <DataInput
                    v-model="filter.source"
                    type="model"
                    placeholder="Quelle"
                    name="source"
                    multiple
                    gql-query="applicantSources"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Berufe - Kategorie</label>
                  <DataInput
                    v-model="filter.occupationField"
                    type="model"
                    placeholder="Berufe - Kategorie"
                    name="occupationField"
                    multiple
                    gql-query="occupationCategories"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Berufsbereich</label>
                  <DataInput
                    v-model="filter.skillJobType"
                    type="model"
                    placeholder="Berufsbereich"
                    multiple
                    gql-query="applicantSkillJobTypes"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Berufe</label>
                  <DataInput
                    v-model="filter.occupation"
                    type="model"
                    placeholder="Berufe"
                    multiple
                    gql-query="occupations"
                    @input="resetPage"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="text-sm opacity-75">Berater</label>
                  <DataInput
                    v-model="filter.internalConsultant"
                    type="model"
                    placeholder="Berater"
                    name="internalConsultant"
                    multiple
                    model-label="
                firstName
                lastName"
                    :select-label="el => el.firstName + ' ' + el.lastName"
                    gql-query="consultantsPage"
                    gql-single-query="consultant"
                    gql-filter-type="objectFilter"
                    @input="resetPage"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="text-sm opacity-75">Benutzergruppe</label>
                  <DataInput
                    v-model="filter.group"
                    type="model"
                    placeholder="Benutzergruppe"
                    multiple
                    name="group"
                    gql-query="userGroups"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Stelle</label>
                  <DataInput
                    v-model="filter.project"
                    type="model"
                    placeholder="Stelle"
                    name="project"
                    multiple
                    model-label="title"
                    gql-query="vacancyProjectPage"
                    gql-filter-type="objectFilter"
                    object-filter-attribute="searchQuery"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Stellenart</label>
                  <DataInput
                    v-model="filter.jobType"
                    type="model"
                    placeholder="Stellenart"
                    name="jobTypes"
                    multiple
                    gql-query="vacancyJobTypes"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Status</label>
                  <DataInput
                    v-model="filter.state"
                    type="model"
                    placeholder="Status"
                    multiple
                    name="state"
                    gql-query="applicantStates"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Status ausschließen</label>
                  <DataInput
                    v-model="filter.excludeState"
                    type="model"
                    placeholder="Status ausschließen"
                    multiple
                    name="exclude-state"
                    gql-query="applicantStates"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75">Anrede</label>
                  <DataInput
                    v-model="filter.salutation"
                    placeholder="Anrede"
                    type="select"
                    :options="salutations"
                    name="salutation"
                    @input="resetPage"
                  />
                </div>
                <div
                  v-if="filter.onlyNew == false"
                  class="vx-col md:w-1/2 w-full"
                >
                  <label class="text-sm opacity-75"
                    >nach Kontaktdatum sortieren</label
                  >
                  <DataInput
                    v-model="orderByContacted"
                    type="bool"
                    name="contactedSince"
                    @input="resetPage"
                  />
                </div>
              </div>
            </vs-collapse-item>
            <vs-collapse-item v-if="filter.onlyNew == false">
              <div slot="header">Erfahrungen</div>
              <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full">
                  <label class="text-sm opacity-75">Bildungsabschluss</label>
                  <DataInput
                    type="model"
                    placeholder="Bildungsabschluss"
                    multiple
                    name="education"
                    @input="resetPage"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="text-sm opacity-75">Berufserfahrung</label>
                  <DataInput
                    v-model="filter.jobExperience"
                    type="model"
                    placeholder="Berufserfahrung"
                    multiple
                    name="jobExperience"
                    gql-query="applicantJobExperiences"
                    @input="resetPage"
                  />
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <label class="text-sm opacity-75">Führungserfahrung</label>
                  <DataInput
                    v-model="filter.leadershipExperience"
                    type="model"
                    placeholder="Führungserfahrung"
                    multiple
                    name="leadershipExperience"
                    gql-query="applicantLeadershipExperiences"
                    @input="resetPage"
                  />
                </div>
              </div>
            </vs-collapse-item>
            <vs-collapse-item v-if="filter.onlyNew == false">
              <div slot="header">Kenntnisse</div>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <label class="text-sm opacity-75">Kenntnisse</label>
                  <DataInput
                    v-model="skillFilter"
                    type="model"
                    placeholder="Kenntnisse"
                    name="skill.skillID"
                    select-label="name"
                    model-label="name
                           inputType
                           skillValues {
                             id
                             name
                           }"
                    multiple
                    gql-query="applicantSkills"
                    @unreduced-input="getSkill"
                    @input="resetPage"
                  />
                </div>
                <div class="vx-col w-full md:w-1/2">
                  <div class="vx-row">
                    <div
                      v-for="(skill, key) in skillFilterObjects"
                      :key="skill.id"
                      class="vx-col w-full"
                    >
                      <label class="text-sm opacity-75">{{ skill.name }}</label>
                      <template v-if="skill.inputType === 'BOOLEAN'">
                        <DataInput
                          v-model="filter.skill[key].value"
                          type="bool"
                          number-value
                          name="skill.value"
                          class="mb-2"
                          @input="resetPage"
                        />
                      </template>
                      <template v-else-if="skill.inputType === 'SELECT'">
                        <DataInput
                          v-model="filter.skill[key].value"
                          type="select"
                          :options="
                            skill.skillValues.map((e, i) => ({
                              label: e.name,
                              code: i
                            }))
                          "
                          name="skill.value"
                          class="mb-2"
                          @input="resetPage"
                        />
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </vs-collapse-item>
          </vs-collapse>
          <div v-if="filter.onlyNew == false" class="filter-group">
            <div class="vx-row clear-both">
              <div
                v-if="currentFilterPreset"
                class="vx-col md:w-1/2 md:mb-4 w-full"
              >
                <vs-button class="w-full" @click="saveCurrentFilter"
                  >Filter Speichern <i class="far fa-save"></i
                ></vs-button>
              </div>
              <div
                v-if="currentFilterPreset"
                class="vx-col md:w-1/2 md:mb-4 w-full"
              >
                <vs-button
                  class="w-full"
                  color="danger"
                  @click="deleteCurrentFilter"
                  >Filter Löschen <i class="far fa-trash"></i
                ></vs-button>
              </div>
              <form class="vx-col w-full">
                <h4>Neue Filtergruppe anlegen</h4>
                <!-- <label class="text-sm opacity-75">Benennung</label> -->
                <ValidationObserver ref="filtergroup" tag="form">
                  <div class="vx-row">
                    <div class="vx-col w-8/12">
                      <DataInput
                        v-model="saveFilterName"
                        validation-rules="required"
                        name="filterName"
                        label="Benennung"
                        placeholder="Benennung"
                      />
                    </div>
                    <div class="vx-col w-4/12">
                      <vs-button class="w-full mt-6" @click="createFilter"
                        >Anlegen</vs-button
                      >
                    </div>
                  </div>
                </ValidationObserver>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { agridMixin } from "@/mixins/agridMixin.js";
import { paginationMixin } from "@/mixins/paginationMixin.js";
import filterToQueryMixin from "@/mixins/filterToQueryMixin.js";
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";
import ApplicantPreview from "./ApplicantPreview";
import salutations from "@/data/enums/Salutation.js";
import ApplicantListEntry from "./ApplicantListEntry";

export default {
  components: {
    DataInput,
    ApplicantPreview,
    ApplicantListEntry
  },
  mixins: [
    paginationMixin("applicantsPage"),
    agridMixin,
    filterToQueryMixin({
      fullTextSearch: String,
      documentTextSearch: String,
      onlyNew: {
        type: Boolean,
        defaultVal: false
      },
      ownCar: Boolean,
      mobilityMotorcycle: Boolean,
      mobilityBicycle: Boolean,
      mobilityPublicTransport: Boolean,
      source: Array,
      occupationField: Array,
      entryType: Array,
      internalConsultant: Array,
      group: Array,
      occupation: Array,
      project: Array,
      state: Array,
      jobType: Array,
      leadershipExperience: Array,
      jobExperience: Array,
      skillJobType: Array,
      salutation: String,
      locationRadius: Number,
      locationLat: Number,
      formatted_address: String,
      noGroup: Boolean,
      skillObject: String,
      locationLng: Number,
      vaccinatedOrRecovered: Boolean,
      onlyOld: Boolean,
      excludeState: Array,
      contactedSince: Date
    })
  ],
  data() {
    return {
      initReady: false,
      currentFilterPreset: null,
      applicantSkill: null,
      skillFilter: [],
      salutations,
      skillFilterObjects: [],
      deleteId: null,
      saveFilterName: "",
      mobileFilterOpen: false,
      setDefaultFilter: false,
      orderByContacted: false
    };
  },
  computed: {
    sortBy() {
      if (this.orderByContacted) {
        return "last_contact";
      } else {
        return null;
      }
    },
    sortDesc() {
      if (this.orderByContacted) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    "$route.params.filterPreset": {
      immediate: true,
      async handler(v, previous) {
        this.setDefaultFilter = false;
        if (this.$route.name === "applicant.preview") {
          return;
        }
        let fromPage = this.$store.state.route.from.path;
        let subString = "/applicant/preview/";
        if (fromPage.includes(subString)) {
          return;
        }

        this.initReady = false;
        this.currentFilterPreset = null;

        if (v === "new") {
          this.resetFilter();
          this.filter.onlyNew = true;
          this.currentPage = 1;
          this.updateFilter(this.filter);
          this.clearFilterFields();
        } else if (v) {
          this.resetFilter();
          if (previous !== v) {
            this.currentPage = 1;
            this.filter.onlyNew = false;
          }

          this.clearFilterFields();
          const { data } = await this.$apollo.query({
            query: gql`
              query($id: ID!) {
                applicantFilterPreset(id: $id) {
                  id
                  name
                  filterJson
                }
              }
            `,
            variables: {
              id: v
            }
          });
          if (data.applicantFilterPreset) {
            this.currentFilterPreset = data.applicantFilterPreset;

            // Add check for changed default Filter and correct filtering after back button in applicant
            let fromPage = this.$store.state.route.from.path;
            let subString = "/applicant/";
            if (fromPage.includes(subString)) {
              return;
            }
            this.filter = Object.assign(
              this.filter,
              JSON.parse(data.applicantFilterPreset.filterJson)
            );
          }

          this.updateFilter(this.filter);

          this.$nextTick(() => {
            if (this.$refs.filtergroup) {
              this.$refs.filtergroup.reset();
            }
          });
        } else {
          this.currentPage = 1;
          this.resetFilter();
          this.clearFilterFields();
          this.filter.onlyNew = false;

          if (this.me && this.me.group && !this.$route.query.noGroup) {
            this.filter.group = [this.me.group.id];
          } else {
            this.setDefaultFilter = true;
          }

          this.updateFilter(this.filter);
        }

        this.initReady = true;
      }
    },
    skillFilter: {
      deep: true,
      handler(value, oldValue) {
        if (value) {
          let skillObject = JSON.stringify(value);
          if (skillObject == JSON.stringify(oldValue)) {
            return;
          }
          this.filter.skillObject = skillObject;
        } else {
          this.filter.SkillObject = undefined;
        }
      }
    },
    currentPage: function() {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 150);
    },
    setDefaultFilter() {
      this.initReady = true;
    },
    filter: {
      deep: true,
      immidiate: false,
      handler(value) {
        //when loading is slow the handler will fire once with the group set to null whereas deliberately removing the group will yield an empty array
        if (value.group !== null && value.group.length < 1) {
          this.filter.noGroup = true;
        } else if (value.group !== null) {
          this.filter.noGroup = undefined;
        }

        if (
          value.skillObject &&
          (!this.skillFilter || this.skillFilter.length < 1)
        ) {
          this.skillFilter = JSON.parse(value.skillObject);
        }
      }
    }
  },
  apollo: {
    applicantsPage: {
      query: gql`
        query ApplicantsPage(
          $page: Int!
          $size: Int
          $filter: ApplicantFilter
          $orderBy: String
          $orderByDesc: Boolean
        ) {
          applicantsPage(
            page: $page
            size: $size
            filter: $filter
            orderBy: $orderBy
            desc: $orderByDesc
          ) {
            total
            results {
              id
              number
              salutation
              firstName
              lastName
              birthday
              imageID
              group {
                id
                name
              }
              defaultProfile {
                id
                wantedOccupation
                salaryWanted
                availibilty {
                  id
                  name
                }
                state {
                  id
                  name
                }
                availibiltyCustom
                internalConsultant {
                  id
                  shorthandSymbol
                  firstName
                  lastName
                }
              }
              contactData {
                telephone
                telephoneMobile
                email
                address {
                  city
                }
              }
              latestHistoryAction {
                id
                createdAt
              }
              readAt
              readBy {
                id
                consultant {
                  id
                  firstName
                  lastName
                }
              }
              createdAt
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.initReady;
      },
      variables() {
        return {
          page: Number(this.currentPage),
          size: this.paginationPageSize,
          filter: Object.prepareGqlInput(
            this.filter,
            [],
            ["address", "formatted_address", "noGroup", "skillObject"]
          ),
          orderBy: this.sortBy,
          orderByDesc: this.sortDesc
        };
      }
    },
    me: {
      query: gql`
        query Me {
          me {
            id
            group {
              id
              name
            }
          }
        }
      `,
      update(value) {
        if (
          this.setDefaultFilter &&
          !this.filter.group &&
          !this.$route.query.noGroup
        ) {
          this.$set(this.filter, "group", [value.me.group.id]);
          this.updateFilter(this.filter);
        }
        this.initReady = true;

        return value.me;
      }
    }
  },
  methods: {
    async getSkill(val) {
      let newFilter = [];

      for (const skill of val) {
        let value = 1;
        for (const currSkill of this.filter.skill || []) {
          if (currSkill.id === skill.id) {
            value = currSkill.value;
          }
        }

        newFilter.push({
          skillID: skill.id,
          value,
          compareType: skill.inputType === "SELECT" ? "GREATER_EQ" : "EQUALS"
        });
      }

      this.$set(this.filter, "skill", newFilter);
      this.skillFilterObjects = val;
    },
    async createFilter() {
      let result = await this.$refs.filtergroup.validate();
      if (result == true) {
        const { data } = await this.$apollo.mutate({
          mutation: gql`
            mutation($input: ApplicantFilterPresetInput!) {
              createApplicantFilterPreset(input: $input) {
                id
                name
                filterJson
              }
            }
          `,
          variables: {
            input: {
              name: this.saveFilterName,
              filterJson: JSON.stringify(this.filter)
            }
          }
        });

        this.currentFilterPreset = data.createApplicantFilterPreset;
        // TODO: Workaround entfernen und Navigation neu laden lassen, dass der Filter sofort sichtbar wird
        setTimeout(() => {
          window.location.reload();
        }, 150);
      }
    },
    async saveCurrentFilter() {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!, $input: ApplicantFilterPresetInput!) {
            updateApplicantFilterPreset(id: $id, input: $input) {
              id
            }
          }
        `,
        variables: {
          id: this.currentFilterPreset.id,
          input: {
            name: this.currentFilterPreset.name,
            filterJson: JSON.stringify(this.filter)
          }
        }
      });

      // TODO: Update in List
    },
    changeAddressFilter(v) {
      this.filter.locationLat = v.lat;
      this.filter.locationLng = v.lng;
      this.filter.formatted_address = v.formatted_address;
      this.filter.locationRadius = 1;
      this.currentPage = 1;
    },
    async deleteCurrentFilter() {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!) {
            deleteApplicantFilterPreset(id: $id) {
              id
            }
          }
        `,
        variables: {
          id: this.currentFilterPreset.id
        }
      });
      setTimeout(() => {
        this.clearFilter();
        this.currentFilterPreset = null;
        setTimeout(() => {
          window.location.assign("/applicants");
        }, 150);
      }, 40);
    },
    clearFilterFields() {
      this.$children.forEach(element => {
        element.internalValue = null;
        element.$children.forEach(element => {
          element.internalValue = null;
          element.$children.forEach(element => {
            element.internalValue = null;
          });
        });
      });
    },
    clearFilter() {
      this.filter = {};
      this.filter.onlyNew = false;
      this.currentPage = 1;
      this.clearFilterFields();
    },
    openPreview(profileId) {
      this.$router.push({
        name: "applicant.preview",
        params: {
          previewid: profileId,
          referer: this.$route.name,
          refererParams: this.$route.params
        }
      });
    },
    confirmDeleteRecord(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei einen Benutzer zu löschen. Wirklich löschen?`,
        accept: this.deleteRecord,
        acceptText: "Löschen"
      });
    },
    deleteRecord() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!) {
              deleteApplicant(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId
          }
        })
        .then(() => {
          this.showDeleteSuccess();
          // TODO: Workaround entfernen und Navigation neu laden lassen, dass der Filter sofort sichtbar wird
          setTimeout(() => {
            window.location.reload();
          }, 150);
        });
    },
    showDeleteSuccess() {
      this.deleteId = null;
      this.$vs.notify({
        color: "success",
        title: "Bewerber gelöscht",
        text: "Der ausgewählte Bewerber wurde gelöscht"
      });
    },
    resetPage() {
      if (this.setDefaultFilter) {
        this.setDefaultFilter = false;
      }
      this.currentPage = 1;
    }
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
<style scoped>
.loading-animation > * {
  display: inline-block !important;
  animation: rotate 1s linear 0s infinite;
}
.loading-animation {
  display: inline-block;
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
</style>
